/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LayoutSettingsDTO } from './LayoutSettingsDTO';
import {
    LayoutSettingsDTOFromJSON,
    LayoutSettingsDTOFromJSONTyped,
    LayoutSettingsDTOToJSON,
} from './LayoutSettingsDTO';
import type { ColorsConfigDTO } from './ColorsConfigDTO';
import {
    ColorsConfigDTOFromJSON,
    ColorsConfigDTOFromJSONTyped,
    ColorsConfigDTOToJSON,
} from './ColorsConfigDTO';
import type { DashboardLayoutsDTO } from './DashboardLayoutsDTO';
import {
    DashboardLayoutsDTOFromJSON,
    DashboardLayoutsDTOFromJSONTyped,
    DashboardLayoutsDTOToJSON,
} from './DashboardLayoutsDTO';
import type { DashboardConfigDTO } from './DashboardConfigDTO';
import {
    DashboardConfigDTOFromJSON,
    DashboardConfigDTOFromJSONTyped,
    DashboardConfigDTOToJSON,
} from './DashboardConfigDTO';
import type { TableViewParamsDTO } from './TableViewParamsDTO';
import {
    TableViewParamsDTOFromJSON,
    TableViewParamsDTOFromJSONTyped,
    TableViewParamsDTOToJSON,
} from './TableViewParamsDTO';
import type { WidgetDTO } from './WidgetDTO';
import {
    WidgetDTOFromJSON,
    WidgetDTOFromJSONTyped,
    WidgetDTOToJSON,
} from './WidgetDTO';

/**
 * 
 * @export
 * @interface NewVersionDashboardDTO
 */
export interface NewVersionDashboardDTO {
    /**
     * 
     * @type {number}
     * @memberof NewVersionDashboardDTO
     */
    autoComparePool?: number;
    /**
     * 
     * @type {string}
     * @memberof NewVersionDashboardDTO
     */
    color?: string;
    /**
     * 
     * @type {ColorsConfigDTO}
     * @memberof NewVersionDashboardDTO
     */
    colorsConfig?: ColorsConfigDTO;
    /**
     * 
     * @type {DashboardConfigDTO}
     * @memberof NewVersionDashboardDTO
     */
    config?: DashboardConfigDTO;
    /**
     * 
     * @type {boolean}
     * @memberof NewVersionDashboardDTO
     */
    draft?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NewVersionDashboardDTO
     */
    icon?: string;
    /**
     * 
     * @type {LayoutSettingsDTO}
     * @memberof NewVersionDashboardDTO
     */
    layoutSettings?: LayoutSettingsDTO;
    /**
     * 
     * @type {DashboardLayoutsDTO}
     * @memberof NewVersionDashboardDTO
     */
    layouts: DashboardLayoutsDTO;
    /**
     * 
     * @type {string}
     * @memberof NewVersionDashboardDTO
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof NewVersionDashboardDTO
     */
    runIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof NewVersionDashboardDTO
     */
    type: NewVersionDashboardDTOTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof NewVersionDashboardDTO
     */
    userExperimentNames?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof NewVersionDashboardDTO
     */
    versionBranch: string;
    /**
     * 
     * @type {string}
     * @memberof NewVersionDashboardDTO
     */
    versionDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof NewVersionDashboardDTO
     */
    versionName?: string;
    /**
     * 
     * @type {TableViewParamsDTO}
     * @memberof NewVersionDashboardDTO
     */
    viewParams?: TableViewParamsDTO;
    /**
     * 
     * @type {Array<WidgetDTO>}
     * @memberof NewVersionDashboardDTO
     */
    widgets: Array<WidgetDTO>;
}


/**
 * @export
 */
export const NewVersionDashboardDTOTypeEnum = {
    Compare: 'compare',
    Experiment: 'experiment',
    Report: 'report'
} as const;
export type NewVersionDashboardDTOTypeEnum = typeof NewVersionDashboardDTOTypeEnum[keyof typeof NewVersionDashboardDTOTypeEnum];


/**
 * Check if a given object implements the NewVersionDashboardDTO interface.
 */
export function instanceOfNewVersionDashboardDTO(value: object): value is NewVersionDashboardDTO {
    if (!('layouts' in value) || value['layouts'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('versionBranch' in value) || value['versionBranch'] === undefined) return false;
    if (!('widgets' in value) || value['widgets'] === undefined) return false;
    return true;
}

export function NewVersionDashboardDTOFromJSON(json: any): NewVersionDashboardDTO {
    return NewVersionDashboardDTOFromJSONTyped(json, false);
}

export function NewVersionDashboardDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewVersionDashboardDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'autoComparePool': json['autoComparePool'] == null ? undefined : json['autoComparePool'],
        'color': json['color'] == null ? undefined : json['color'],
        'colorsConfig': json['colorsConfig'] == null ? undefined : ColorsConfigDTOFromJSON(json['colorsConfig']),
        'config': json['config'] == null ? undefined : DashboardConfigDTOFromJSON(json['config']),
        'draft': json['draft'] == null ? undefined : json['draft'],
        'icon': json['icon'] == null ? undefined : json['icon'],
        'layoutSettings': json['layoutSettings'] == null ? undefined : LayoutSettingsDTOFromJSON(json['layoutSettings']),
        'layouts': DashboardLayoutsDTOFromJSON(json['layouts']),
        'name': json['name'],
        'runIds': json['runIds'] == null ? undefined : json['runIds'],
        'type': json['type'],
        'userExperimentNames': json['userExperimentNames'] == null ? undefined : json['userExperimentNames'],
        'versionBranch': json['versionBranch'],
        'versionDescription': json['versionDescription'] == null ? undefined : json['versionDescription'],
        'versionName': json['versionName'] == null ? undefined : json['versionName'],
        'viewParams': json['viewParams'] == null ? undefined : TableViewParamsDTOFromJSON(json['viewParams']),
        'widgets': ((json['widgets'] as Array<any>).map(WidgetDTOFromJSON)),
    };
}

export function NewVersionDashboardDTOToJSON(value?: NewVersionDashboardDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'autoComparePool': value['autoComparePool'],
        'color': value['color'],
        'colorsConfig': ColorsConfigDTOToJSON(value['colorsConfig']),
        'config': DashboardConfigDTOToJSON(value['config']),
        'draft': value['draft'],
        'icon': value['icon'],
        'layoutSettings': LayoutSettingsDTOToJSON(value['layoutSettings']),
        'layouts': DashboardLayoutsDTOToJSON(value['layouts']),
        'name': value['name'],
        'runIds': value['runIds'],
        'type': value['type'],
        'userExperimentNames': value['userExperimentNames'],
        'versionBranch': value['versionBranch'],
        'versionDescription': value['versionDescription'],
        'versionName': value['versionName'],
        'viewParams': TableViewParamsDTOToJSON(value['viewParams']),
        'widgets': ((value['widgets'] as Array<any>).map(WidgetDTOToJSON)),
    };
}

